import React from 'react';
import styled from 'styled-components/macro';
import { Header, Paragraph, Section } from '../components/Typography';

const PrivacyStatement = () => (
  <>
    <Section>
      <Header>Privacy statement E-learning</Header>
      <Paragraph>Created on the 22nd of October 2024</Paragraph>
    </Section>
    <Section>
      <SubHeader>How do we collect personal data?</SubHeader>
      <Paragraph>
        Boost.ai uses the learning management system software Docebo to host the
        boost.ai e-learning platform. In order to access the boost.ai e-learning
        platform, you should have rightful access to an admin panel which will
        be linked to the boost.ai e-learning platform through a single sign on
        authentication.
      </Paragraph>
      <Paragraph>
        If you no longer have access to an admin panel, you will also lose
        access to the boost.ai e-learning platform.
      </Paragraph>
      <Paragraph>
        When accessing the boost.ai e-learning platform, the following types of
        personal data about you may be collected and stored:
      </Paragraph>
      <Paragraph>
        <strong>Account and profile information:</strong> data about when your
        account is created, and when you modify your profile or set preferences.
        This information may include: first name, last name, username, email,
        password, account creation date and last access date.
      </Paragraph>
      <Paragraph>
        <strong>Interactions within the service:</strong> your progress,
        interaction with and scores for the elements within the system, for
        example videos you watched, tests and/or assignments you completed.
      </Paragraph>
      <Paragraph>
        <strong>Content you provide to the service:</strong> all the content
        that you post, send, receive and share through the Services.
      </Paragraph>
    </Section>
    <Section>
      <SubHeader>How and why we use the personal data we collect</SubHeader>
      <Paragraph>
        We collect your personal data in order to provide you with the training
        and educational services and certifications that you requested from us
        and to build a higher quality, more useful service.
      </Paragraph>
      <Paragraph>
        Collected personal data will be used by, and accessible to boost.ai
        employees, agents and partners under existing confidentiality
        obligations.
      </Paragraph>
      <Paragraph>
        We may archive all collected personal data and use it for providing
        and/or improving the services and/or for future communications with you
        where we are legally entitled to do so.
      </Paragraph>
      <Paragraph>
        All data that is processed in the e-learning platform will be stored at
        boost.ai’s environment at Docebo’s cloud server which is hosted by
        Amazon Web Services.
      </Paragraph>
      <Paragraph>
        We may share your personal data with government authorities or third
        parties in response to legal processes, to establish or exercise our
        legal rights or to protect our property, to defend against legal claims
        or otherwise required by law. We may also share your personal data when
        it is appropriate to audit, investigate, prevent or take action
        regarding illegal or suspected illegal activities, to protect and defend
        the rights, property or safety of Boost.ai, our users, customers and in
        connection with our Terms of Use and other agreements.
      </Paragraph>
      <Paragraph>
        Because the internet is not 100% secure, we cannot guarantee the
        security of your personal data. It is your responsibility to protect the
        security of your login information.
      </Paragraph>
    </Section>
    <Section>
      <SubHeader>How long do we keep the data</SubHeader>
      <Paragraph>
        All data collected within the system will be retained for as long as it
        is necessary for fulfilling the purpose it was collected for or as
        required in order to comply with applicable laws and to establish,
        exercise or defend our legal rights.
      </Paragraph>
      <Paragraph>
        The data may be deleted upon request. Despite requests for deletion we
        may continue to store your data if necessary in order to comply with
        applicable laws and regulations.
      </Paragraph>
    </Section>
    <Section>
      <SubHeader>Onboarding admin panel</SubHeader>
      <Paragraph>
        All training data created within the onboarding admin panel will be
        deleted after 14 days counting from the date you have been granted
        access to the onboarding admin panel. A backup of the deleted data will
        be kept in Amazon Web Services cloud for 30 days before permanent
        deletion. This data is deleted due to limited capacity of the system and
        the nature of the activity which is only testing of the service.
      </Paragraph>
      <Paragraph>
        Remember that once you lose your access to the onboarding admin panel,
        you will no longer be able to access the e-learning platform unless you
        have rightful access to another admin panel, therefore we encourage you
        to download any certificates of course completion you would like to
        keep.
      </Paragraph>
      <Paragraph>
        If you have any questions or requests about your personal data, please
        contact us via{' '}
        <a href="mailto:elearning@boost.ai">elearning@boost.ai</a>
      </Paragraph>
      <Paragraph>
        Please note that we review our privacy practices from time to time and
        that these practices are subject to change. Any changes will be
        effective immediately upon publication. You will be notified of updates
        before accessing the platform again.
      </Paragraph>
    </Section>
  </>
);

const SubHeader = styled.h3`
  #certiself-form & {
    color: #552a55;
    font-size: 22px;
    margin-bottom: 17px;
  }
`;

export default PrivacyStatement;
